import { postEnrollmentToken } from '../../adapters/NX5/NX5_EnrollmentTokenAdapter';
import {
  EnrollmentTokenError,
  enrollmentErrorMessage,
  formatEnrollmentToken,
  isValidMachineUdi,
  readEnrollmentBody,
} from './enrollmentToken';

export const requestEnrollmentToken = (machineUdi) => {
  const machine_udi = String(machineUdi ?? '').trim();
  if (!isValidMachineUdi(machine_udi)) {
    return Promise.reject(new EnrollmentTokenError(400, enrollmentErrorMessage(400)));
  }

  return postEnrollmentToken(machine_udi)
    .then((res) => {
      const status = res?.status;
      if (status < 200 || status >= 300) {
        throw new EnrollmentTokenError(status, enrollmentErrorMessage(status));
      }

      const body = readEnrollmentBody(res?.data);
      const enrollment_token = formatEnrollmentToken(body?.enrollment_token);
      const expires_at = body?.expires_at == null ? '' : String(body.expires_at);
      if (!enrollment_token || !expires_at) {
        throw new EnrollmentTokenError(status, 'The enrollment response did not include a code and expiry.');
      }

      return {
        machine_udi: body.machine_udi == null ? machine_udi : String(body.machine_udi),
        enrollment_token,
        expires_at,
      };
    })
    .catch((err) => {
      if (err instanceof EnrollmentTokenError) {
        throw err;
      }
      const status = err?.response?.status;
      throw new EnrollmentTokenError(status, enrollmentErrorMessage(status));
    });
};
